// Local library
import { CommonFacade } from '@amwager/data-access';
import { FundingFacade, IAccountACH } from '@amwager/funding/data-access';
import { UnsubscribeObservableService } from '@amwager/util';

// Angular
import {
  CommonModule
} from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormGroup,
  FormBuilder,
  Validators
} from '@angular/forms';

// Ionic library
import {
  IonIcon,
  IonCheckbox,
  ModalController,
  AlertController
} from '@ionic/angular/standalone';

// Third party
import {
  Subscription,
  Observable,
  takeUntil,
  of
} from 'rxjs';

@Component({
  selector: 'feature-ion-add-account',
  templateUrl: './add-account.component.html',
  styleUrls: ['./add-account.component.scss'],
  imports: [
    CommonModule,
    IonIcon,
    IonCheckbox,
    ReactiveFormsModule
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddAccountComponent extends UnsubscribeObservableService implements OnInit {

  private subsAddAccountResponse!: Subscription;
  tmsId?: string;
  addAccountForm!: FormGroup;
  isAgree: boolean = false;
  isProcessing: boolean = false;
  @Output() showAddAccountFormFn = new EventEmitter<boolean>();

  // convenience getter for easy access to form fields
  get formVal() { return this.addAccountForm?.controls }

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly fundingFacade: FundingFacade,
    private readonly elementRef: ElementRef,
    private readonly commonFacade: CommonFacade,
    private readonly modalCtrl: ModalController,
    private readonly alertCtrl: AlertController
  ) {
    super();

  }

  ngOnInit() {
    this.observerTmsIds();
    this.initForm();

    this.addAccountForm.get('routingName')?.valueChanges.subscribe((value) => {

      if (value) {
        const isNumeric = /^[0-9]*$/.test(value);
        if (!isNumeric) {
          this.addAccountForm.get('routingName')?.setErrors({ invalidCharacters: true });
        }

        else if (value.toString().length < 9 || value.toString().length > 9) {
          this.addAccountForm.get('routingName')?.setErrors({maxlength: true});
        }
      }
    });

    this.addAccountForm.get('accountNumber')?.valueChanges.subscribe((value) => {

      if (value) {
        const isNumeric = /^[0-9]*$/.test(value);
        if (!isNumeric) {
          this.addAccountForm.get('accountNumber')?.setErrors({ invalidCharacters: true });
        }

        // value.toString().length > 6
        else if (value.toString().length < 6) {
          this.addAccountForm.get('accountNumber')?.setErrors({minlength: true});
        }

        else if (value.toString().length > 20) {
          this.addAccountForm.get('accountNumber')?.setErrors({maxlength: true});
        }
      }
    });
  }

  private observerTmsIds(): void {
    this.commonFacade?.tmsId$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((tmsId: string | undefined) => {
        this.tmsId = tmsId;
      });
  }

  private initForm(): void {
    this.addAccountForm = this.formBuilder.group({
      bankName: ['', [Validators.required]],
      routingName: ['', [Validators.required]],
      accountType: ['', [Validators.required]],
      accountNumber: ['', [Validators.required]]
    });

    this.addAccountForm.get('accountType')?.setValue('PC');
  }

  toggleCheckbox(): void {
    this.isAgree = !this.isAgree;
  }

  addAccount(): void {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('AddAccountComponent:addAccount', false);
      return;
    }

    if (this.addAccountForm.valid && this.isAgree) {

      this.isProcessing = true;

      const accountACH: IAccountACH = {
        AchAccount: this.addAccountForm.get('accountNumber')?.value,
        AchRoute: this.addAccountForm.get('routingName')?.value,
        AchAccounttype: this.addAccountForm.get('accountType')?.value,
        AccountId: 0,
        AchName: this.addAccountForm.get('bankName')?.value,
      }
      this.isAgree = false;

      this.fundingFacade.addAccountACH(
        accountACH
      );

      this.subsAddAccountResponse = this.fundingFacade.isAddAchAccountSuccess$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe(({response, isSuccess}) => {

        if (isSuccess) {

          this.addAccountForm.reset();
          this.fundingFacade.getAchAccount();

          this.isProcessing = false;
          this.showAddAccountFormFn.emit(true);

          this.subsAddAccountResponse?.unsubscribe();
          return;
        }

        if (isSuccess !== undefined && isSuccess === false) {
          this.isProcessing = false;
          this.showAlertMessage('Error', response?.error?.Message);
          this.subsAddAccountResponse?.unsubscribe();
          return;
        }

        // this.addAccountForm.reset();
        // this.fundingFacade.getAchAccount();

        // this.isProcessing = false;
        // this.showAddAccountFormFn.emit(true);

        // this.subsAddAccountResponse?.unsubscribe();
      });

    }
  }

  closeForm(): void {
    this.showAddAccountFormFn.emit(true);
  }

  async showAlertMessage(header: string, message: string): Promise<void> {
    const alert = await this.alertCtrl.create({
      header,
      message: message,
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });

    await alert.present();
  }

}
